import { useMemo } from 'react';
import { HARMONY_PORTAL_CHAT } from '@rsos/capstone/src/constants/capabilities';
import { HARMONY_PORTAL_CHAT_PERMISSION } from '@rsos/constants/permissions';
import { useFlag } from '@rsos/flags';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';

const useHasAccessToHarmonyPortalChat = () => {
  const hasHarmonyPortalChatCapabilities =
    useHasCapability(HARMONY_PORTAL_CHAT);
  const hasHarmonyPortalChatPermission = useHasPermission(
    HARMONY_PORTAL_CHAT_PERMISSION,
  );
  const hasHarmonyChatFlag = useFlag('harmony_portal_chat');
  const hasAccessToHarmonyPortalChatFeature = useMemo(() => {
    return (
      !!hasHarmonyPortalChatCapabilities?.hasCapability &&
      !!hasHarmonyPortalChatPermission?.hasPermission &&
      !!hasHarmonyChatFlag
    );
  }, [
    hasHarmonyPortalChatCapabilities,
    hasHarmonyPortalChatPermission,
    hasHarmonyChatFlag,
  ]);

  return hasAccessToHarmonyPortalChatFeature;
};

export default useHasAccessToHarmonyPortalChat;
